export default {
  payment: {
    paymentForm: {
      modal: {
        title: "Платіж"
      },
      form: {
        abcode: "Особовий рахунок",
        fullname: "ПІБ абонента",
        address: "Домашня адреса",
        dateBegin: "Дата створення",
        dateEnd: "Дата закриття",
        payTab: {
          title: "Платіж",
          datePay: "Дата оплати",
          dateBank: "Дата по банку",
          sumPay: "Сума платежу",
          numPayDoc: "Номер платіжного документа",
          methodPay: "Спосіб оплати",
          orgPay: "Організація",
          accountPay: "Розрахунковий рахунок",
          purpPay: "Призначення платежу",
          statusPay: "Статус платежу",
          datePayFrom: "Період оплати з",
          datePayTo: "по",
          sumPayMust: "Обов'язковий платіж",
          dateSaveReadings: "Дата зняття показань",
          counter: "Лічильник",
          dateReading: "Показання на",
          current: "Поточне",
          difference: "Різниця"
        },
        actTab: {
          title: "Погашення по акту",
          act: "Акт",
          actDate: "Дата:",
          actSum: "Сума:",
          actType: "Тип:",
          note: "Примітка"
        },
        noteTab: {
          title: "Примітка"
        }
      },
      abcodeNotFound: "Особовий рахунок не найден",
      info: {
        add: "Додавання запису",
        edit: "Зміна запису",
        del: "Повернення платежу"
      },
      actSwitcher: "F2 - Акт",
      buttons: {
        AddReadingOneZone: "Додати показання",
        AddReadingTwoZone: "Додати показання 2-зонного лічильника",
        AddReadingThreeZone: "Додати показання 3-зонного лічильника",
        DeleteReading: "Видалити показання"
      },
      alert: {
        pointNumberCannotBeEmpty: "Номер точки обліку не може бути порожнім",
        modifyCurrentRecord: "Здійснити зміну поточного запису?",
        makeRefund: "Здійснити повернення платежу?",
        confirmMakeRefund:
          "Ви точно впевнені у поверненні цього платежу абоненту?",
        actExistsNoChangeAbcode:
          "До даного платежу прив'язаний акт, зміна особового рахунку неможлива"
      }
    },
    searchSubscribersForm: {
      modal: {
        title: "Пошук абонентів"
      },
      form: {
        fio: "ПІБ",
        street: "Вулиця",
        house: "Будинок",
        corpHouse: "Корпус будинку",
        flat: "Квартира",
        ncount: "№ лічильника",
        nplomb: "№ пломби",
        inn: "ІПН",
        eic: "EIC",
        abcode: "Особовий рахунок",
        abcodeBegin: "Л/рахунок відкритий",
        abcodeEnd: "закритий",
        area: "Район",
        nact: "№ акта",
        fioPerson: "Прізвище фіз. особи",
        nbid: "Номер заявки",
        naccount: "№ рахунку",
        ncontract: "№ договору",
        phone: "Телефон",
        nHouseAccount: "№ будинкового лічильника"
      },
      extendedSearch: "F2 Розширений пошук",
      help: {
        message1:
          '<p>Умови пошуку розбиті на дві частини: основні та додаткові. Основні - ПІБ, Вулиця, Будинок, Квартира, Лічильник. Додаткові (Номер акта, дати Створення та закриття особового рахунку, Район) відображаються, якщо встановити прапорець "Розширений пошук".</p>',
        message2:
          "<p>Введені символи запам'ятовуються і автоматично з'являються при повторному виклику форми.</p>",
        message3:
          '<p>Пошук ведеться за сукупністю всіх зазначених ознак. Додаткові умови враховуються тільки при встановленому прапорці "Розширений пошук".</p>',
        message4:
          '<p>Прізвище, № лічильника, № акта і особовий рахунок можна вказувати частково, якщо встановити прапорці "входження".</p>',
        message5:
          '<p>Пошук по цих полях також може здійснюватися по масці: символ "?" означає один будь-який символ, символ "*" - нуль або більше символів.</p>',
        message6:
          '<p>(прапорці входження - це окремий випадок маски, їх установка аналогічна приписування "*" на початку і в кінці введеного значення).</p>'
      }
    },
    searchResultsForm: {
      modal: {
        title: "Результат вибірки"
      },
      selectedRows: "Відібрано записів:"
    }
  }
};
